import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CustomerService } from '../../customer/services/customer.service';
import { PaymentPlan, PaymentPlanDefaults } from '../model/payment-plan';
import * as moment from 'moment';
import { OperationService } from '../service/operation.service';
import { ModelUtils } from 'src/app/common/utility/model.utils';
import { ConfirmationDialogService } from 'src/app/common/component/confirmation-dialog/confirmation-dialog.service';
import { PaymentHubComponent } from '../payment-hub.component';
import { PaymentHubService } from '../service/payment-hub.service';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
declare var CollectJS: any;


@Component({
  selector: 'recurring',
  templateUrl: './recurring.component.html',
  styleUrls: ['../payment-hub.component.css', './recurring.component.css']
})
export class RecurringComponent implements OnInit {

    LABEL_ACCOUNT_NUMBER: string;
    LABEL_TERMS: string;
    LABEL_INVOICE_NUMBER: string;
    LABEL_ACCOUNT_NAME: string;
    LABEL_CUSTOMER: string;
    LABEL_INVOICE_DATE: string;
    LABEL_PAYMENT_LIMIT: string;
    LABEL_PAYMENT_FREQUENCY: string;
    LABEL_PLAN: string;

    brands: any;
    rules: any[];
    payments: any[];
    wallets: any[];
    walletAll: any[];
    accounts: any[];
    frequencies: any;
    events: any;
    wallet: any;
    paymentPlan: PaymentPlan;
    currentButton: number;
    currentStep: number;
    isEditing: boolean;
    paymentMethod: any;
    paymentMethod2: any;
    rule: any;
    payment: any;
    body: any;
    walletType: string;
    agree: boolean;
    formCardSubmitted: boolean;
    formBankSubmitted: boolean;
    formPaymentPlanSubmitted: boolean;
    formPaymentPlanPaySubmitted: boolean;
    formReviewPaymentPlanSubmitted: boolean;
    endDateValidation: boolean;

    username: string;
    transactionId: string;
    defaultSettings: any;
    accountId: string;

    autoPay: number;
    onSubmitLoader: boolean;
    cardErr: any;
    collectJSFields: any;
    response: any;
    refreshIntervalId: any;
    isDisabled: boolean;
    isNicknameSelected: boolean;
    isCCpayment: boolean;
    cards: any;
    selectedPaymentMethod: any;
    currentDate: any;
    tomorrowDate: any;
    validUsPhoneNumber: any;

    achBusinessAccount: any;
    keypadDataLocked: boolean;

    // Wallet ================================================================
    billingId: string;

    constructor(private ref: ChangeDetectorRef, private operationService: OperationService, private customerService: CustomerService, private confirmationDialogService: ConfirmationDialogService, private paymentHubService: PaymentHubService, public paymentHubComponent: PaymentHubComponent) {
    this.rules = undefined;
    this.walletAll = [];
    this.wallets = [];
    this.events = PaymentPlanDefaults.paymentEvents;
    this.frequencies = [];
    this.paymentPlan = new PaymentPlan();
    this.walletType = undefined;
    this.agree = false;
    this.isCCpayment = false;
    this.payments = undefined;

    this.username = '';
    this.transactionId = '';
    this.currentButton = -1;
    this.isEditing = false;
    this.formCardSubmitted = false;
    this.formBankSubmitted = false;
    this.formPaymentPlanSubmitted = false;
    this.formPaymentPlanPaySubmitted = false;
    this.formReviewPaymentPlanSubmitted = false;
    this.endDateValidation = false;
    this.autoPay = 0;
    this.paymentMethod = '';
    this.paymentMethod2 = '';
    this.cards = undefined;
    this.refreshIntervalId = '';
    this.response = {};
    this.isDisabled = false;
    this.formCardSubmitted = false;
    this.formBankSubmitted = false;
    this.isNicknameSelected = false;
    this.validUsPhoneNumber = true;
    this.onSubmitLoader = false;
    this.response = {
          currentDate: '',
          currentTime: '',
          tomorrowDate: ''
      };
    this.selectedPaymentMethod = '';
    this.currentDate = {
          year: parseInt(moment(new Date()).format('YYYY')),
          month: parseInt(moment(new Date()).format('MM')),
          day: parseInt(moment(new Date()).format('DD'))
      };
    const today = new Date();
    const tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000));
    this.tomorrowDate = {
		  year: parseInt(moment(tomorrow).format('YYYY')),
          month: parseInt(moment(tomorrow).format('MM')),
          day: parseInt(moment(tomorrow).format('DD'))
      };
    console.log('tomorrow:' + this.tomorrowDate.year + ' ' + this.tomorrowDate.month + ' ' + this.tomorrowDate.day);
    this.cardErr = {
      checkname: {
        flag: false,
        msg: ''
      },
      ccnumber: {
        flag: false,
        msg: ''
      },
      ccexp: {
        flag: false,
        msg: ''
      },
      cvv: {
        flag: false,
        msg: ''
      },
      checkaba: {
        flag: false,
        msg: ''
      },
      checkaccount: {
        flag: false,
        msg: ''
      },
    };

    this.achBusinessAccount = false;
    this.keypadDataLocked = false;
  }

  ngOnInit(): void {
    this.username = localStorage.getItem(PaymentPlanDefaults.CONSTANT_USERNAME);
    this.transactionId = localStorage.getItem(PaymentPlanDefaults.CONSTANT_TRANSACTION_ID);
    this.defaultSettings = JSON.parse(localStorage.getItem(PaymentPlanDefaults.CONSTANT_DEFAULT_SETTINGS));
    this.loadBranding();
    this.loadRules();
  }


  // UI methods

    loadBranding() {
        this.paymentHubService.branding().subscribe(res => {
            if (res.status !== 200) {
                alert(res.body);
                return;
            }
            this.brands = res.body;
            if (this.brands) {
                this.LABEL_ACCOUNT_NUMBER = this.getText('2', 'Account Number');
                this.LABEL_INVOICE_DATE = this.getText('4', 'Invoice Date');
                this.LABEL_INVOICE_NUMBER = this.getText('3', 'Invoice Number');
                this.LABEL_ACCOUNT_NAME = this.getText('1', 'Name');
                this.LABEL_CUSTOMER = this.getText('5', 'Customer');
                this.LABEL_TERMS = this.getText('6', 'Terms and conditions');
            }
        }, err => {
            console.log(err);
            alert(err.error.message);
        });
    }

    getText(label: string, defaultValue: string): string {
        const val = this.brands.find((x: { dbId: string; }) => x.dbId === label);
        return val == null || false ? defaultValue : val.text;
    }

  // ---------------------------------------

    changePaymentMethod(type: string) {
        this.selectedPaymentMethod = type;
        if (this.selectedPaymentMethod !== 'wallet') {
            this.paymentPlan.wallet.walletObj = '';
        }

        this.ref.detectChanges();
    }

    selectPaymentMethod() {
        if (this.selectedPaymentMethod === 'wallet') {
          this.paymentMethod = '';
          this.paymentMethod2 = '';
          if (this.paymentPlan.wallet.walletObj.ccNumber){
            this.paymentMethod = 'Card number: ' + this.paymentPlan.wallet.walletObj.ccNumber;
            this.paymentMethod2 = '';
            this.isCCpayment = true;
          } else {
            this.paymentMethod = 'Account number: ' + this.paymentPlan.wallet.walletObj.accountNumber;
            this.paymentMethod2 = 'Routing number: ' + this.paymentPlan.wallet.walletObj.routingNumber;
            this.isCCpayment = false;
          }
          this.toggleStep(3);
        } else {
            this.toggleWallet(this.selectedPaymentMethod);
        }
    }

  toggleButton(currentButton: number, isEdit: number) {
    this.autoPay = 0;
    if (currentButton === 1) {
      this.LABEL_PLAN = 'Autopay';
      this.LABEL_PAYMENT_LIMIT = 'Payment Limit';
      this.LABEL_PAYMENT_FREQUENCY = 'Payment Date';
    } else {
      this.LABEL_PLAN = 'Payment Plan';
      this.LABEL_PAYMENT_LIMIT = 'Payment Amount';
      this.LABEL_PAYMENT_FREQUENCY = 'Payment Frequency';
    }

    if (isEdit === 0) {
      this.isEditing = false;
    }
    if (currentButton !== -1) {
      this.toggleStep(1);
      this.load(currentButton === 1 ? true : false, currentButton);
    } else {
      this.toggleView(currentButton);
      this.toggleStep(-1);
    }
  }

  public getAccountTooltip(){
    let tooltipMessage = '';
    if (this.currentButton === 1){
      tooltipMessage = 'Select the account you wish to establish an automatic payment rule. A rule can only be added to one account at a time.';
    }else{
      tooltipMessage = 'Select the account you wish to establish a payment plan. A payment plan can only be added to one account at a time.';
    }

    return tooltipMessage;
  }

  public getFrequencyTooltip(){
    let tooltipMessage = '';
    if (this.currentButton === 1){
      tooltipMessage = 'This determines the date on which the automatic payment will be processed for the open statement or invoice. If the payment date falls on a weekend or bank holiday, then the payment will be processed the following business day.';
    }else{
      tooltipMessage = 'This determines how often you would like payments to be drawn. If Weekly is selected, payments will be pulled on the same day every week. The day is determined by the start date selected.  If Bi Weekly is selected the payments will be drawn on the same day every other week. If Monthly is selected the payments will be drawn on the same date every month determined by the start date selected.' +
      'Weekly Example, if this rule is set up on a start date on a Monday and Weekly is selected for Payment Frequency, the payments will be drawn every Monday. Monthly Example, if the start date for the rule is set as the 5th of the month and Monthly is selected as the Payment Frequency, the payment will be drawn on the 5th of every month.';
    }

    return tooltipMessage;
  }

  public getEndEventTooltip(){
    let tooltipMessage = '';
    if (this.currentButton === 1){
      tooltipMessage = 'This determines when an automatic payment rule expires. If By Date is selected, then the rule will expire on the selected end date. If By Number of Payments is selected, then the rule will expire after the set number of payments have been processed. If Indefinite is selected, then the rule will not expire until the rule is deleted.';
    }else{
      tooltipMessage = 'This determines when the payment plan expires. If By Date is selected, then the payment plan will expire on the selected end date. If By Number of Payments is selected, then the payment plan will expire after the set number of payments have been processed. If Indefinite is selected, then the payment plan will not expire until the rule is deleted.';
    }

    return tooltipMessage;
  }

  toggleView(currentButton: number) {
    this.paymentPlan = new PaymentPlan();
    this.currentButton = currentButton;
    this.formPaymentPlanSubmitted = false;
    this.formPaymentPlanPaySubmitted = false;
    this.formReviewPaymentPlanSubmitted = false;
    this.loadRules();
    this.toggleStep(1);
  }

  onEventChange() {
    this.paymentPlan.event.endEvent = this.paymentPlan.event.endEventObj.id;
    if (this.currentButton === 2) {
      this.paymentPlan.paymentIsFull = false;
    } else {
      this.paymentPlan.paymentIsFull = true;
    }
    this.paymentPlan.amount = '0';
    this.paymentPlan.event.numberOfPayment = 1.0;
  }

  onUpdate(rule: any) {
    this.isEditing = true;
    this.rule = ModelUtils.deepclone(rule);
    this.selectedPaymentMethod = 'wallet';
    if (this.rule.frequency.frequencyType === 'PLAN') {
      this.toggleButton(2, 1);
    } else {
      this.toggleButton(1, 1);
    }
  }

  toggleStep(step: number) {
    if (step === 1) {
      this.agree = false;
    }
    this.currentStep = step;
  }

  onEnroll() {
    this.displayLoadingImage();
    this.singleplan();
  }

  load(isAutoPay: boolean, currentButton: number) {
    this.loadAccounts(isAutoPay, currentButton);
  }

  // ----------------------------------------

  // REST services
    private singleplan() {
    this.response = JSON.parse(JSON.stringify(this.paymentPlan));
    this.response.sid = this.isEditing ? this.rule.sid : -1;
    this.response.frequency = this.paymentPlan.frequencyObj.sid;
    this.response.event.endEvent = this.paymentPlan.event.endEventObj.id;
    this.response.account = this.paymentPlan.accountObj.sid;
    const strDate = this.paymentPlan.event.startDate;
    const edDate = this.paymentPlan.event.endDate;
    const startDate = JSON.parse(JSON.stringify(strDate));
    const endDate = JSON.parse(JSON.stringify(edDate));

    this.response.event.startDate = moment(new Date(startDate.year, startDate.month - 1, startDate.day)).format('YYYY-MM-DD');
    this.response.event.endDate = this.paymentPlan.event.endEvent === 0 ? moment(new Date(endDate.year, endDate.month - 1, endDate.day)).format('YYYY-MM-DD') : null;

    this.response.wallet = this.paymentPlan.wallet.walletObj;
    this.response.amount = (typeof this.paymentPlan.amount === 'string') ? this.paymentPlan.amount.replace('$', '') : this.paymentPlan.amount;

    this.operationService.rule(this.transactionId, this.response).subscribe(res => {
          if (res.status !== 200) {
              alert(res.body);
              return;
          }
          const today = new Date();
          const tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000));
          const usaTimeToday = today.toLocaleString('en-US', { timeZone: 'America/New_York' });
          const usaTimeTomorrow = tomorrow.toLocaleString('en-US', { timeZone: 'America/New_York' });
          this.response.currentDate = (new Date(usaTimeToday)).toISOString();
          this.response.tomorrowDate = (new Date(usaTimeTomorrow)).toISOString();
          this.toggleStep(4);
          this.disableLoadingImage();
    }, err => {
      console.log(err);
      alert(err.error.message);
    });
  }

  onDelete(rule: any, body: any) {
  this.confirmationDialogService.confirm(ConfirmationDialogService.getRuleDeleteMesage(rule.account.accountNumber))
        .then((confirmed) => {
          if (!confirmed) {
            return;
          }
          this.operationService.deleteRule(this.transactionId, rule.sid)
            .pipe(switchMap(() => {
                if (rule.frequency.frequencyType === 'AUTO_PAY') {
                    return this.operationService.cancelScheduledAutopayments(rule.wallet.billerId , rule.sid, body);
                } else {
                    return of(null);
                }
              })
            ).subscribe(
                  (res) => {
                    if (res && res.status !== 200) {
                    alert(res.body);
                    return;
                    }
                    this.rules = [];
          }, err => {
                         console.log(err);
                         alert(err.error.message);
                     });
               }
         ).catch(() => {});
         }


  private loadWallets(type: boolean = false): void {
    this.operationService.wallets(this.transactionId).subscribe(res => {
      if (res.status !== 200) {
        alert(res.body);
        return;
      }
      this.wallets = res.body;
      console.log('wallets:' + this.wallets);
      this.walletAll = res.body;
      if (this.isEditing || type) {
        const sid = type ? this.wallet.sid : this.rule.wallet.sid;
        this.paymentPlan.wallet.walletObj = this.walletAll.find(wallet => wallet.sid === sid);
      } else {
        this.paymentPlan.wallet.walletObj = '';
      }
    }, err => {
      console.log(err);
      alert(err.error.message);
    });
  }


  private loadAccounts(isAutoPay: boolean, currentButton: number): void {
    this.customerService.accounts(this.transactionId).subscribe(res => {
      if (res.status !== 200) {
        alert(res.body);
        return;
      }
      this.accounts = res.body;

      if (this.isEditing) {
        this.toggleView(currentButton);
        this.paymentPlan.accountObj = this.accounts.find(acc => acc.sid === this.rule.account.sid);
      } else {
        let count = 0;
        this.accounts.forEach(function(item) {
          if (item.allowNew) {
            count++;
          }
        });
        if (count > 0) {
          this.toggleView(currentButton);
        } else {
          this.autoPay = currentButton;
        }
        if (this.accounts.length === 1){
          this.paymentPlan.accountObj = this.accounts[0];
        }
      }

      this.loadFrequencies(isAutoPay);
    }, err => {
      console.log(err);
      alert(err.error.message);
    });
  }


  private loadRules(): void {
    this.operationService.rules(this.transactionId).subscribe(res => {
      if (res.status !== 200) {
        alert(res.body);
        return;
      }
      this.rules = res.body;
    }, err => {
      console.log(err);
      alert(err.error.message);
    });
  }


  private loadFrequencies(isAutoPay: boolean) {
    this.operationService.frequencies(isAutoPay).subscribe(res => {
      if (res.status !== 200) {
        alert(res.body);
        return;
      }
      this.frequencies = res.body;

      if (this.isEditing) {
        this.paymentPlan.frequencyObj = this.frequencies.find((freq: { sid: any; }) => freq.sid === this.rule.frequency.sid);
        this.paymentPlan.event.endEventObj = this.events.find((event: { id: any; }) => event.id === this.rule.event.endEvent);
        this.paymentPlan.event.endEvent = this.rule.event.endEvent;
        const startDate = moment(this.rule.event.startDate);
        const endDate = moment(this.rule.event.endDate);
        console.log(this.rule.event.endDate);
        this.paymentPlan.event.startDate = {
          year: startDate.year(),
          month: startDate.month() + 1,
          day: startDate.date()
        };
        this.paymentPlan.event.endDate = {
          year: endDate.year(),
          month: endDate.month() + 1,
          day: endDate.date()
        };

        this.paymentPlan.paymentIsFull = this.rule.paymentIsFull;
        this.paymentPlan.amount = this.rule.amount;
        this.paymentPlan.contact.email = this.rule.contact.email;
        this.paymentPlan.contact.phoneNumber = this.rule.contact.phoneNumber;
        this.paymentPlan.event.numberOfPayment = this.rule.event.numberOfPayment;
      }

      this.loadWallets();
    }, err => {
      console.log(err);
      alert(err.error.message);
    });
  }


  validateEndDate(data: any) {
    const sDate = this.paymentPlan.event.startDate;
    const eDate = this.paymentPlan.event.endDate;
    if (sDate && eDate) {
      const startDate = new Date(sDate.year + '/' + sDate.month + '/' + sDate.day);
      const endDate = new Date(eDate.year + '/' + eDate.month + '/' + eDate.day);
      if (endDate < startDate) {
        this.paymentPlan.event.endDate = '';
        this.endDateValidation = true;
      } else {
        this.endDateValidation = false;
      }
    }
  }


  toggleWallet(walletType: string) {
      this.formCardSubmitted = false;
      this.formBankSubmitted = false;
      this.keypadDataLocked = false;

      if (walletType === 'none') {
          this.walletType = '';
          this.currentStep = 3;
      } else if (walletType === 'back') {
          this.walletType = '';
          this.currentStep = 2;
      } else {
          this.wallet = {
              sid: null,
              name: '',
              nickname: '',
              zipCode: '',
              tokenId: null,
              tokenType: null,
              card: null,
              checkAccount: null
          };

          this.walletType = walletType;
          this.toggleStep(-1);

          if (walletType === 'card' || walletType === 'bank') {
              this.loadCollectJS();
          }
      }
  }


  public loadCollectJS() {
    this.ref.detectChanges();

    this.collectJSFields = {
      checkname: {
        placeholder: this.walletType === 'card' ? 'Name on Card' : 'Name on Account',
        selector: '#ccName'
      },
      ccnumber: {
        placeholder: '0000 0000 0000 0000',
        selector: '#ccNumber'
      },
      ccexp: {
        placeholder: '00/00',
        selector: '#ccExp'
      },
      cvv: {
        placeholder: '000 or 0000',
        selector: '#cvv'
      },
      checkaba: {
        placeholder: 'Routing Number',
        selector: '#routingNo'
      },
      checkaccount: {
        placeholder: 'Account Number',
        selector: '#acNumber'
      }
    };

    CollectJS.configure({
      paymentSelector: '#collectJsSubmissionTrigger',
      variant: 'inline',
      styleSniffer: true,
      validationCallback: (field: string | number, status: any, message: any) => {
        if (status) {
          this.cardErr[field] = {
            flag: false,
            msg: ''
          };
        } else {
          this.cardErr[field] = {
            flag: true,
            msg: message
          };
        }
        console.log(this.cardErr);
        this.ref.detectChanges();
      },
      timeoutDuration: 10000,
      timeoutCallback: () => {
        this.disableLoadingImage();
        console.log('The tokenization didn\'t respond in the expected timeframe.  This could be due to an invalid or incomplete field or poor connectivity');
      },
      fieldsAvailableCallback: () => {
        console.log('Collect.js loaded the fields onto the form');
      },
      callback: (response: any) => {
        console.log(response);
        this.handleNmiResponseAndContinue(response);
      },
      fields: this.collectJSFields
    });

    this.startCollectJsWalletRequest();
    this.ref.detectChanges();
  }


  startCollectJsWalletRequest() {
    CollectJS.startPaymentRequest();
  }


  handleNmiResponseAndContinue(response: any) {
      console.log(this.wallet);
      console.log(this.isEditing);

      let card = null;
      let checkAccount = null;

      if (this.walletType === 'card') {
          card = {
              cardNumber: response.card.number,
              expDate: response.card.exp
          };
          this.paymentMethod = 'Card number: ' + response.card.number;
          this.paymentMethod2 = '';
          this.isCCpayment = true;
      } else {
          checkAccount = {
              routingNumber: response.check.aba,
              accountNumber: response.check.account,
              businessAccount: this.achBusinessAccount
          };
          this.paymentMethod = 'Account number: ' + response.check.account;
          this.paymentMethod2 = 'Routing number: ' + response.check.aba;
          this.isCCpayment = false;
      }
      this.changePaymentMethod('wallet');

      this.wallet.sid = this.isEditing ? this.wallet.sid : null;
      this.wallet.name = response.check.name;
      this.wallet.tokenId = response.token;
      this.wallet.tokenType = 'COLLECT_JS';
      this.wallet.card = card;
      this.wallet.checkAccount = checkAccount;

      this.addWallet();
  }


    handleKeypadSubmission() {
        this.wallet.sid = this.isEditing ? this.wallet.sid : null;

        // THIS WILL NEED TO BE MADE A SWITCH IN THE FUTURE
        if (this.paymentHubComponent.keypadType === 'M100') {
            this.wallet.tokenType = 'KEYPAD_M100_M130_KEYED_DATA';
        }

        this.paymentMethod = 'Keypad';
        this.paymentMethod2 = '';

        // THIS.WALLET.CARD IS CREATED AND VALUES NULL BECAUSE WALLET TYPE DETERMINATION IS BRILLIANTLY BASED ON CARD OR
        // CHECKACCOUNT BEING NULL OR NOT AND WITH KEYPADS WE RECEIVE NO CARD DATA IN THE RESPONSE, UNLIKE COLLECT.JS

        this.wallet.card = {
            cardNumber: null,
            expDate: null
        };

        this.addWallet();
    }


    private addWallet() {
        this.operationService.addWallet(this.transactionId, this.wallet).subscribe(
            res => {
                if (res.status !== 200) {
                    alert(res.body);
                    this.onSubmitLoader = false;
                }

                this.wallet = res.body.wallet;
                this.loadWallets(true);
                this.paymentPlan.wallet.walletObj = this.wallet;

                this.toggleWallet('none');
                this.disableLoadingImage();
            }, err => {
                console.log(err);
                alert(err.error.message);
                this.onSubmitLoader = false;
            });

        this.toggleStep(-1);
    }


  public displayLoadingImage(){
    this.onSubmitLoader = true;
    this.ref.detectChanges();
  }


  public disableLoadingImage(){
    this.onSubmitLoader = false;
    this.ref.detectChanges();
  }


  printPage() {
    window.print();
  }


  public isValidUsPhoneNumber(phoneNumber: any){
    const regexp = new RegExp('^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$');
    const plainPhoneNumberRegexp = new RegExp('^[0-9]{10}$');
    // if empty then consider it to be a valid state
    if (phoneNumber === undefined || phoneNumber.length === 0){
        this.validUsPhoneNumber = true;
    }else{
        this.validUsPhoneNumber = regexp.test(phoneNumber) || plainPhoneNumberRegexp.test(phoneNumber);
    }

    return this.validUsPhoneNumber;
  }

    // KEYPAD FUNCTIONALITY

    lockKeypadDataFieldIfInputValid() {
        // THIS WILL NEED TO BE MADE A SWITCH IN THE FUTURE
        if (this.paymentHubComponent.keypadType === 'M100') {
            if (this.wallet.tokenId.length === 160) {
                this.keypadDataLocked = true;
                this.ref.detectChanges();
            }
        }
    }
}
